import { OwnershipCheckmarkProps } from '../../types/components/shared/OwnershipCheckmark';

import { CheckmarkIcon } from '../../modules/Icons';
import { Tooltip } from 'react-tooltip';

const OwnershipCheckmark: React.FC<OwnershipCheckmarkProps> = ({
  owned,
  tooltipKey,
  className,
}) => {
  if (!owned.fully && !owned.partially) return;
  return (
    <div cy-test-id="ownership-checkmark" className={`absolute top-[8px] right-[8px] xl:top-[12px] xl:right-[12px] flex items-center p-1 rounded-[5px] bg-[rgba(0,0,0,.6)] ${className ?? ''}`}>
      {owned.fully && (
        <CheckmarkIcon
          className="block w-3 h-3 xl:w-4 xl:h-4 stroke-a-green"
          data-tooltip-id={`${tooltipKey}-ownership`}
          data-tooltip-content="Fully owned"
        />
      )}
      {owned.partially && (
        <CheckmarkIcon
          className="block w-3 h-3 xl:w-4 xl:h-4"
          color={'white'}
          data-tooltip-id={`${tooltipKey}-ownership`}
          data-tooltip-content="Partially owned"
        />
      )}
      <Tooltip id={`${tooltipKey}-ownership`} opacity={1} style={{ backgroundColor: 'black' }} />
    </div>
  );
}

export default OwnershipCheckmark;
